export default [
  {
    title: 'Upcoming Tasks',
    route: 'task-list',
    icon: 'CheckCircleIcon',
    resource: 'task',
    action: 'read',
  },
  {
    title: 'Task Templates',
    route: 'process-list',
    icon: 'CopyIcon',
    resource: 'process',
    action: 'read',
  },
  {
    title: 'People',
    route: 'user-list',
    icon: 'UsersIcon',
    resource: 'user',
    action: 'read',
  },
  {
    title: 'Roles',
    route: 'role-list',
    icon: 'AwardIcon',
    resource: 'role',
    action: 'read',
  },
]
